<template>
    <div class="orderDetail">
        <div class="orderDetail-left custom-description">
            <el-descriptions :column="2" size="medium" :colon="false" border>
                <el-descriptions-item label="订单号">
                    <span @dblclick="$utils.dblclickCopy">{{ orderInfo.orderNo }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="订单状态">
                    <el-tag size="small" :type="orderInfo.status | filterConst('HITCHHIKINGDAN', 'type')">{{
                        orderInfo.status |
                        filterConst('HITCHHIKINGDAN') }}</el-tag>
                    <el-tooltip placement="top" style="margin-left: 5px;" v-if="orderInfo.status == 60">
                        <div slot="content">
                            {{ orderInfo.cancelChannel | fliterCancelChannel }}:{{ orderInfo.cancelReason }}
                        </div>
                        <el-icon :size="16" class="el-icon-question"></el-icon>
                    </el-tooltip>
                </el-descriptions-item>
                <el-descriptions-item label="三方订单">
                    <span @dblclick="$utils.dblclickCopy">{{ orderInfo.partnerOrderId }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="订单来源">
                    {{ orderInfo.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}
                </el-descriptions-item>
                <el-descriptions-item label="订单类型">
                    <el-tag :type="orderInfo.cityType == 1 ? 'warning' : 'success'">{{ orderInfo.cityType == 1 ? '城际' : '市内' }}</el-tag>
                    <el-tag style="margin-left: 5px;" :type="orderInfo.poolType == 1 ? 'primary' : 'success'">{{ orderInfo.poolType == 1 ? '独享' : '拼车' }}</el-tag>
                    <el-tag style="margin-left: 5px;" :type="orderInfo.bearHighwayFeeType == 2 ? 'info' : ''">{{ orderInfo.bearHighwayFeeType | filterConst("BEARHIGHWAYFEE") }}</el-tag>
                </el-descriptions-item>

                <el-descriptions-item label="下单乘客">
                    {{ orderInfo.realPhoneSuffix }} . {{ orderInfo.passengerNum }}人
                </el-descriptions-item>
                <el-descriptions-item label="订单金额">
                    <span class="util-money">¥{{ orderInfo.amount }}</span>
                    <span style="margin-left: 4px;"> ({{ orderInfo.distance || 0 }}km) </span>
                </el-descriptions-item>
                <el-descriptions-item label="预约出发">
                    {{ orderInfo.earliestDepartureTime | filterTime }} - {{ orderInfo.latestDepartureTime |
                        filterDepartureTime(orderInfo.earliestDepartureTime) }}
                </el-descriptions-item>

                <el-descriptions-item label="司机信息"> {{ orderInfo.driverName || '-' }} - (<span
                        @dblclick="$utils.dblclickCopy">{{ orderInfo.driverPhone || '-' }}</span>)
                </el-descriptions-item>
                <el-descriptions-item label="车辆号牌">
                    <span v-if="orderInfo.licenseNo" :style="getPlateStyle(orderInfo.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(orderInfo.licenseNo) }}</span>
                    <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="机构名称">
                    {{ orderInfo.organizationName || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="所属渠道">
                    {{ orderInfo.channelName || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="备注"> {{ orderInfo.message || '-' }} </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="orderDetail-right">
            <orderLine :rowData="orderInfo"></orderLine>
        </div>
    </div>
</template>

<script>
import orderLine from './orderLine.vue'
export default {
    name: 'orderDetail',
    components: {
        orderLine
    },
    props: {
        orderInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {}
    },
    mounted() {
       
    },
    methods: {}
}
</script>

<style lang="less" scoped>
.orderDetail {

    &-left {

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            margin-top: 16px;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }

        :deep(.el-descriptions-row) {
            display: flex;
        }

        :deep(.el-descriptions-item__cell) {
            border-top: 0;
            border-left: 0;
        }

        :deep(.el-descriptions-item__label.is-bordered-label) {
            width: 110px;
            background-color: #FBFBFB;
        }

        :deep(.el-descriptions-item__content) {
            flex: 1;
        }
    }

    &-right{
        width: 100%;
        height: 500px;
        margin-top: 16px;
    }
}
</style>
